"use client";

import { QueryProvider } from "../queryProvider";
import ToastProvider from "./toastProvider";
import { AuthProvider } from "@/features/auth/hooks/useAuth";
import { Session } from "next-auth";
import EmbedChatbot from "../embedChatbot";
import InitLogRocket from "../initLogrocket";
import { LocaleProvider } from "@/hooks/useLocale";
import { Locale } from "../localization";

interface ProviderProps {
    children: React.ReactNode;
    session: Session | null;
    locale: Locale;
    dir: "rtl" | "ltr";
    isMobile: boolean;
}

export const GlobalProviders = ({
    children,
    session,
    locale,
    dir,
    isMobile,
}: ProviderProps) => {
    return (
        <QueryProvider>
            <AuthProvider session={session} isMobile={isMobile}>
                <InitLogRocket />
                <EmbedChatbot />
                <LocaleProvider locale={locale} dir={dir}>
                    <ToastProvider />
                    {children}
                </LocaleProvider>
            </AuthProvider>
        </QueryProvider>
    );
};
